export const ScheduleSharing = {
    None: 0,
    Static: 1,
    FightsOrder: 2,
    FightsRealTime: 3,
};

export type ScheduleSharingType = (typeof ScheduleSharing)[keyof typeof ScheduleSharing];

export type Schedule = {
    id: number;
    eventId: number;
    name: string;
    sharing: ScheduleSharingType;
    startTime: string;
    plannedVersionAvailable: boolean;
};
